<div class="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4" (click)="onClose()">
  <div
    class="bg-white rounded-xl shadow-lg w-full max-w-lg max-h-[85vh] flex flex-col"
    (click)="$event.stopPropagation()"
  >
    <div class="p-4 border-b flex items-center justify-between">
      <span class="font-bold text-purple-700">{{ phoneNumber }}</span>
      <button
        type="button"
        (click)="onClose()"
        class="text-gray-400 hover:text-gray-700 text-xl leading-none w-6 h-6 flex items-center justify-center"
      >
        &times;
      </button>
    </div>

    <div class="flex-1 overflow-y-auto p-6 space-y-3">
      @if (showHistory()) {
        @for (message of messages(); track message.id) {
          <ng-container [ngTemplateOutlet]="bubble" [ngTemplateOutletContext]="{ $implicit: message }" />
        } @empty {
          <p class="text-center text-gray-400 mt-10">Nema poruka za prikaz</p>
        }
      } @else {
        @if (lastClientMessage(); as last) {
          <ng-container [ngTemplateOutlet]="bubble" [ngTemplateOutletContext]="{ $implicit: last }" />
        } @else {
          <p class="text-center text-gray-400 mt-10">Nema poruka klijenta.</p>
        }
        @for (message of sentMessages(); track message.id) {
          <ng-container [ngTemplateOutlet]="bubble" [ngTemplateOutletContext]="{ $implicit: message }" />
        }
      }
    </div>

    <ng-template #bubble let-message>
      <div class="flex" [ngClass]="message.mine ? 'justify-end' : 'justify-start'">
        <div
          class="max-w-md rounded-2xl px-4 py-2 shadow-sm"
          [ngClass]="
            message.mine ? 'bg-purple-600 text-white rounded-br-sm' : 'bg-white text-gray-800 border rounded-bl-sm'
          "
        >
          <p class="whitespace-pre-wrap break-words">{{ message.message }}</p>
          <p class="text-[10px] mt-1 text-right" [ngClass]="message.mine ? 'text-purple-200' : 'text-gray-400'">
            {{ message.created_at | date: 'dd.MM.yyyy HH:mm' }}
          </p>
        </div>
      </div>
    </ng-template>

    @if (!historyOnly) {
      <div class="p-4 bg-white border-t space-y-2">
        <textarea
          #messageInput
          class="w-full border rounded-lg p-2 focus:ring-2 focus:ring-purple-500 outline-none resize-none"
          rows="3"
          placeholder="Kucaj poruku..."
          [(ngModel)]="messageText"
        ></textarea>
        <div class="flex justify-between">
          <button
            type="button"
            (click)="sendMessage()"
            [disabled]="!messageText().trim()"
            class="px-8 py-2 bg-purple-600 text-white rounded-lg font-bold hover:bg-purple-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            POŠALJI
          </button>
          <button
            type="button"
            (click)="showFullHistory()"
            class="px-4 py-1.5 border border-purple-600 rounded-lg text-purple-700 hover:bg-purple-50 text-xs font-bold transition-colors"
          >
            ISTORIJA
          </button>
        </div>
      </div>
    }
  </div>
</div>
